import React, {useEffect, useState} from "react";
import { Button, Badge, ButtonDropdown } from "reactstrap";
import { allowAction } from "../redux/permissions.reducer";
import { authenticationService } from "../services/authentication";
import {useAppDispatch, useAppSelector} from "../redux/store";

type AuthorizeProps = { onAuth?: () => void, path?: string, action?: string, children: React.ReactNode };
function Authorize(props: AuthorizeProps) {
  const permissions = useAppSelector((state) => state.permissions.permissions);
  const dispatch = useAppDispatch();

  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const path = props.path || window.location.hash.substring(1).split('?')[0];
    const action = props.action || 'view';

    if (permissions[path] && permissions[path][action] !== undefined) {
      permissions[path][action] && props.onAuth && props.onAuth();
      setAuthorized(permissions[path][action]);
    } else {
      authenticationService.checkAction(path, action)
        .then((allowed) => {
          allowed && props.onAuth && props.onAuth();
          dispatch(allowAction({ path, action, allowed }));
          setAuthorized(allowed);
        })
    }
  }, []);

  if (!authorized || !props.children)
    return null;

  return (
    <>{props.children}</>
  )
}

export function ButtonWithAuth(props: any) {
  return (
    <Authorize {...props}>
      <Button {...props}>
        {props.children || props.text}
      </Button>
    </Authorize>
  )
}

export function BadgeWithAuth(props: any) {
  return (
    <Authorize {...props}>
      <Badge {...props}>
        {props.text}
      </Badge>
    </Authorize>
  )
}

export function ButtonDropDownWithAuth(props: any) {
  return (
    <Authorize {...props}>
      <ButtonDropdown {...props}>
        {props.text}
      </ButtonDropdown>
    </Authorize>
  )
}

export default Authorize;
